<i18n>
{
  "th": {
    "datePicker": {
      "placeholder": "เลือกวันที่",
      "allDate": "เวลา"
    }
  }
}
</i18n>
<template>
  <v-menu
    v-model="menu"
    :close-on-content-click="false"
    :nudge-right="40"
    transition="scale-transition"
    offset-y
    max-width="290px"
    min-width="290px">
    <template v-slot:activator="{ on, attrs }">
      <v-text-field
        :value="dateDisplay"
        :height="height"
        class="input-time"
        append-icon="mdi-alarm"
        readonly
        outlined
        dense
        hide-details
        v-bind="attrs"
        v-on="on">
      </v-text-field>
    </template>
    <v-time-picker
      :value="dateDisplay"
      :format="format"
      full-width
      @input="changeDate($event)" />
  </v-menu>
</template>

<script>
export default {
  props: {
    value: {
      type: [String, Array],
      default: ''
    },
    height: {
      type: [String, Number],
      default: '40px'
    },
    format: {
      type: String,
      default: 'ampm'
    }
  },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    dateDisplay () {
      if (!this.value) return this.$t('datePicker.allDate')
      const date = this.$dayjs(this.value, ['YYYY-MM-DD:H:mm', 'H:mm']).format('H:mm')
      return date
    }
  },
  methods: {
    changeDate (value) {
      this.$emit('input', value)
    }
  }
}
</script>
<style lang="scss" scoped>

</style>
